import { useEffect, useRef } from 'react';

import type { CheckoutSessionResponse } from '../api/checkout';
import { getSession } from '../api/checkout';

export interface StatusPollerProps {
  checkoutId: string;
  sessionId: string;
  intervalMs?: number;
  onSession: (session: CheckoutSessionResponse) => void;
}

/** Polls session status for live payment updates. */
export default function StatusPoller({
  checkoutId,
  sessionId,
  intervalMs = 10_000,
  onSession,
}: StatusPollerProps) {
  const onSessionRef = useRef(onSession);
  onSessionRef.current = onSession;

  useEffect(() => {
    let cancelled = false;

    const poll = async () => {
      try {
        const s = await getSession(checkoutId, sessionId);
        if (!cancelled) onSessionRef.current(s);
      } catch {
        /* ignore transient errors */
      }
    };

    void poll();
    const id = window.setInterval(poll, intervalMs);
    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, [checkoutId, sessionId, intervalMs]);

  return null;
}
